import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/PricingCalculator';
import { connect } from 'react-redux';
import { Col, ControlLabel, FormGroup, Form, Button, FormControl, Modal, HelpBlock } from 'react-bootstrap';
import { MarginStars } from './MarginStars';
import NumberFormat from 'react-number-format';
import './PricingCalculator.css';

import 'font-awesome/css/font-awesome.min.css';

class PricingCalculator extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showDetails: false,
            showConfirmation: false,
            showError: false,
            errorMessage: '',
            newPrice: 0.00,
            newMargin: 0.0
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.toggleClass = this.toggleClass.bind(this);
        this.savePriceOrQuote = this.savePriceOrQuote.bind(this);
        this.updatePrice = this.updatePrice.bind(this);
        this.updateMargin = this.updateMargin.bind(this);
        this.exitMarginInput = this.exitMarginInput.bind(this);
        this.exitPriceInput = this.exitPriceInput.bind(this);
        this.selectFocus = this.selectFocus.bind(this);
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        }

        if (!localStorage.getItem('selectedProduct')) {
            window.open('/product-search', '_self');
        }

        const productId = localStorage.getItem('selectedProduct');
        const unitOfMeasure = localStorage.getItem('selectedProductUM');
        const customer = localStorage.getItem('customer');
        const addressId = localStorage.getItem('address');

        var that = this;

        //e.g.: http://localhost:60065/pricing-calculator/C114579/0033045/HEW12C/EA
        this.props.queryPriceCalc({ customer, addressId, productId, unitOfMeasure }, () => {
            that.setState({ newPrice: this.props.product.Price });
        });
    }

    componentDidMount() {
        this.setState({ newPrice: this.props.product.Price });
        this.setState({ newMargin: this.props.product.Margin });
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    selectFocus(e) {
        e.target.select();
    }

    handleClose() {
        this.setState({ showConfirmation: false });
        this.setState({ showError: false });
    }

    handleShow() {
        this.setState({ showConfirmation: true });
    }

    toggleClass() {
        const currentState = this.state.showDetails;
        this.setState({ showDetails: !currentState });
    };

    updatePrice(e) {
        var price = e.target.value;

        this.setState({ newPrice: price });
    }

    updateMargin(e) {
        var margin = e.target.value;

        this.setState({ newMargin: margin });
    }

    exitPriceInput(e) {
        var price = e.target.value;

        if (price < this.props.product.Cost) {
            price = this.props.product.Cost;

            this.setState({ errorMessage: "New price is below cost." });
            this.setState({ showError: true });
        }

        this.setState({ newPrice: Number(price).toFixed(2) },
            () =>
                this.setState({
                    newMargin: ((this.state.newPrice - this.props.product.Cost) / this.state.newPrice * 100).toFixed(1)
                })
        );
    }

    exitMarginInput(e) {
        var margin = e.target.value;

        if (margin >= 100) {
            margin = 99.9;
        }

        if (margin < 0) {
            margin = 0;
            this.setState({ errorMessage: "New price is below cost." });
            this.setState({ showError: true });
        }

        this.setState({ newMargin: Number(margin).toFixed(1) },
            () =>
                this.setState({
                    newPrice: (this.props.product.Cost / (1 - this.state.newMargin / 100)).toFixed(2)
                })
        );
    }

    savePriceOrQuote() {
        this.handleClose();

        var call = {};
        call.target = {};
        call.target.value = this.props.product.Price;

        //console.log('newPrice call (saveOrQuote) ', call);

        this.exitPriceInput(call); // the price isn't setting server-side, set the logic to work

        const productId = localStorage.getItem('selectedProduct');
        const unitOfMeasure = localStorage.getItem('selectedProductUM');
        const customer = localStorage.getItem('customer');
        const addressId = localStorage.getItem('address');

        //console.log("new price (props) ", this.props.product.Price);
        //console.log("new price ", this.state.newPrice);

        var newPrice = this.props.product.Price;
        var updatePrice = this.props.product.AllowPriceEdit;

        if (updatePrice && this.state.newPrice) {
            //console.log('setting new price in savePriceOrQuote method')
            newPrice = this.state.newPrice;

            if (newPrice < this.props.product.Cost) {
                return;
            }
        }

        this.props.queryPriceCalc({ customer, addressId, productId, unitOfMeasure, newPrice, updatePrice });

        this.setState({ newPrice: this.newPrice });
        this.setState({ newMargin: this.newMargin });

        console.log('Sleeping to allow record write to server...');

        setTimeout(() => {
            console.log('Sleep finished.')

            window.location.reload();
        }, 1000);
    };

    render() {
        return (
            <div style={{ maxWidth: '642px' }}>
                <h1>Pricing Calculator</h1>
                <Col lg={6} xs={12} md={6}>
                    <Form>
                        <FormGroup
                            controlId="priceCalcForm">
                            <ControlLabel>Selected Customer:</ControlLabel>

                            <p>
                                <span className='price-calc-customer'>
                                    [{localStorage.getItem('customer')}] {localStorage.getItem('customerName')} 
                                    <br />[{localStorage.getItem('address')}] {localStorage.getItem('addressName')}
                                    <br />{localStorage.getItem('street')}
                                    <br />{localStorage.getItem('city')}, {localStorage.getItem('state')} {localStorage.getItem('zip')}
                                </span>
                            </p>

                            <ControlLabel>Selected Product:</ControlLabel>
                            <br />
                            <p>
                                <b style={{ fontStyle: 'underline' }}>
                                    <a href="/product-search" style={{ color: "#4D721E" }}>
                                        <i className={'fa fa-search'}
                                            style={{
                                                cursor: 'pointer',
                                                color: "black",
                                                marginRight: "5px"
                                            }}
                                        />
                                        {this.props.product.Id}
                                    </a>
                                </b>
                            </p>
                            <p><b>{this.props.product.Name}</b></p>

                        </FormGroup>
                    </Form>

                    <table>
                        <thead>
                            <tr>
                                <td>UM</td>
                                <td>Warehouse</td>
                                <td>Status</td>
                                <td>QoH</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b className="price-calc-status">{this.props.product.UnitOfMeasure}</b></td>
                                <td><b className="price-calc-status">{this.props.product.Warehouse}</b></td>
                                <td><b className="price-calc-status">{this.props.product.Status}</b></td>
                                <td><b className="price-calc-status">{this.props.product.QuantityOnHand}</b></td>
                            </tr>
                        </tbody>
                    </table>

                    <br />

                    <MarginStars
                        showDetails={this.state.showDetails}
                        cost={Number(this.props.product.Cost)}
                        price={this.state.newPrice > 0 ? this.state.newPrice : this.props.product.Price}
                        account={localStorage.getItem('customer')}
                        itemId={this.props.product.Id}
                    />

                    <div style={{ width: '208px' }}>
                        <p className="inline">
                            Current Price: <NumberFormat value={this.props.product.Price} thousandSeparator={true}
                                displayType={'text'} prefix={''} className="price-calc-price price-calc-current-price"
                                fixedDecimalScale={true} decimalScale={2} />
                        </p>
                        <p className={this.state.showDetails ? 'inline' : 'hide-details'} style={{ float: 'right' }}>
                        <NumberFormat value={this.props.product.Margin} thousandSeparator={true}
                            displayType={'text'} prefix={''} className="price-calc-price price-calc-current-margin"
                            fixedDecimalScale={true} decimalScale={1} />
                        </p>
                    </div>
                    
                    <p className={this.state.showDetails ? '' : 'hide-details'}>
                        Current Cost: <NumberFormat value={this.props.product.Cost} thousandSeparator={true}
                            displayType={'text'} prefix={''} className="price-calc-price price-calc-current-cost"
                            fixedDecimalScale={true} decimalScale={2} />
                    </p>

                    <p className={this.state.showDetails ? 'hide-details' : ''}>
                        <b className="price-calc-price">{this.props.product.PriceLevel}</b>
                    </p>

                    <FormGroup>
                        <FormControl
                            type="number"
                            pattern="\d*"
                            inputmode="decimal"
                            onBlur={this.exitPriceInput}
                            defaultValue={this.props.product.Price}
                            onFocus={e => e.target.select()}
                            onChange={this.updatePrice}
                            value={this.state.newPrice}
                            defaultValue={this.state.newPrice > 0 ? this.state.newPrice : this.props.product.Price}
                            readOnly={!this.props.product.AllowPriceEdit}
                            className={this.state.showDetails ? 'inline price-calc-new-price price-calc-new-price-input' : 'price-calc-new-price price-calc-new-price-input'} />

                        <input
                            type="number"
                            pattern="\d*"
                            inputmode="decimal"
                            onBlur={this.exitMarginInput}
                            onChange={this.updateMargin}
                            onFocus={e => e.target.select()}
                            value={this.state.newMargin}
                            defaultValue={this.state.newMargin > 0 ? this.state.newMargin : this.props.product.Margin}
                            readOnly={!this.props.product.AllowPriceEdit}
                            className={this.state.showDetails ? 'price-calc-new-margin price-calc-new-margin-input inline form-control' : 'hide-details'} />

                        <br className={this.state.showDetails ? 'show-details' : 'hide-details'} />
                        <HelpBlock className="inline price-calc-new-price-label">New Price</HelpBlock>
                        <HelpBlock className={this.state.showDetails ? 'price-calc-new-margin price-calc-new-margin-label' : 'hide-details'}>New GP%</HelpBlock>


                        <Button className="price-calc-button" block onClick={this.handleShow}>
                            Save {this.props.product.AllowPriceEdit ? 'Price' : 'Quote'}
                        </Button>

                        <br />

                        <Button className="price-calc-button" onClick={this.toggleClass}>
                            Toggle Details...
                        </Button>
                    </FormGroup>

                    {/*<p> <b>{this.props.product.PriceMethod}</b></p>*/}
                    <p className={this.state.showDetails ? '' : 'hide-details'}>
                        Current Price Type: <br />
                        <b className="price-calc-price">{this.props.product.PriceLevel}</b>
                    </p>
                    <p className={this.state.showDetails ? '' : 'hide-details'}>
                        Current Cost Type: <br /><b className="price-calc-price">
                            {
                                this.props.product.CostType === 'Deviated cost' ?
                                    this.props.product.CostType + ': ' + this.props.product.ContractName
                                    :
                                    this.props.product.CostType
                            }</b>
                    </p>

                    <Modal show={this.state.showConfirmation} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <h3>
                                <center>
                                    {this.props.product.AllowPriceEdit && this.state.newPrice > 0 ?
                                    'Save the item price as'
                                    :
                                    this.props.product.AllowPriceEdit ?
                                        'Save to customer history?'
                                        :
                                        'Price cannot be modified. Add product to Order Planner anyhow?'}
                                    <br />
                                
                                    {/* The below sucked to write as much as it sucks to read, sorry! */}
                                    {
                                        this.props.product.AllowPriceEdit ?
                                            this.state.newPrice > 0 ?
                                                '$' + this.state.newPrice
                                            :
                                                ''/*'$' + this.props.product.Price*/
                                        : ''
                                    }
                                    {
                                        this.props.product.AllowPriceEdit && this.state.newMargin >= 0 && this.state.showDetails ? ' at ' + this.state.newMargin + '% GP' : ''
                                    }
                                    {
                                        this.props.product.AllowPriceEdit && this.state.newPrice > 0 ? ' ?' : ''
                                    }


                                </center>
                            </h3>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.savePriceOrQuote}>Yes</Button>
                            <Button onClick={this.handleClose}>No</Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showError} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Error</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h4>{this.state.errorMessage}</h4>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.handleClose}>OK</Button>
                        </Modal.Footer>
                    </Modal>
                </Col>
                <Col lg={6} xs={12} md={6}>
                    <h4 className="web-name"><b>{this.props.product.BrandName} {this.props.product.WebName}</b></h4>

                    <img src={this.props.product.ImagePathXL} className='price-calc-image' alt={this.props.product.WebName} />
                    <Col>
                        <ul className="web-selling-point">
                            {this.props.product.SellingPoints
                                && this.props.product.SellingPoints.map(sellingPoint =>
                                <li key={sellingPoint} className='sellingpoint'><b>{sellingPoint}</b></li>
                            )}
                        </ul>
                    </Col>
                </Col>
            </div>
        );
    }
}

export default connect(
    state => state.pricingCalculator || {},
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PricingCalculator);



// WEBPACK FOOTER //
// ./src/components/sales/PricingCalculator.js